<template>
  <div class="partsrequest">
    <Fieldset class="p-shadow-8">
      <template #legend>
        <p>
          {{ user.persno }} | {{ user.firstname }} <b>{{ user.lastname }}</b>
        </p>
      </template>
      <b>Submit Your Indirect Labor Hours!</b>

      <hr class="rounded" />
    </Fieldset>
  </div>
</template>

<script>
import Fieldset from "primevue/fieldset";

import { fb_auth, fb_storage, fb_db } from "../firebase";

export default {
  name: "PartsRequest",
  components: {
    Fieldset,
  },

  data() {
    return {
      form: {
        bumper: null,
        notification: null,
        desc: null,
        niin: null,
        qty: null,
        ui: null,
      },
      parts: [],
    };
  },

  async mounted() {
    await this.$store.dispatch("getAdmins");
  },

  methods: {
    onUpload(e) {
      console.log("Uploading file....", e.files);
      this.uploading = true;
      let file = e.files[0];
      var uploadTask = fb_storage.child("uploads/" + file.name).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + this.progress + "% done");
        },
        function (error) {
          // Handle unsuccessful uploads
        },
        function () {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
            // update some collection with this url
            fb_db.collection("parts").doc("DVkYRdF9aNCQl2BMVUKS").update({
              image: downloadURL,
            });
            this.uploading = false;
          });
        }
      );
    },
    addPart() {
      if (!this.form.bumper) {
        console.log("no bumper");
        this.$toast.add({
          severity: "warn",
          summary: "No bumper #",
          detail: "Please select a bumper number.",
          life: 3000,
        });
      } else if (!this.form.notification) {
        console.log("no notification");
        // toast here
      } else if (!this.form.desc) {
        console.log("no desc");
        // toast here
      } else if (!this.form.niin) {
        console.log("no niin");
      } else if (!this.form.qty) {
        console.log("no qty");
        // toast here
      } else {
        let temp_bumper = this.form.bumper;
        let temp_notification = this.form.notification;
        this.parts.push(this.form);
        this.form = {};
        this.form.bumper = temp_bumper;
        this.form.notification = temp_notification;
      }
    },
    removePart(index) {
      this.parts.splice(index, 1);
    },
    sendPartstodb() {
      this.parts.forEach((p) => {
        fb_db.collection("parts").add({
          notifiction: p.notification,
          desc: p.desc,
          admin: p.bumper,
          created: new Date(),
          qty: p.qty,
          user: fb_db.collection("users").doc(fb_auth.currentUser.uid),
        });
      });
      this.parts = [];
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Parts Uploaded.",
        life: 3000,
      });
    },
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    user() {
      return this.userProfile;
    },
    admins() {
      return this.$store.state.admins;
    },
  },
};
</script>

<style lang="scss" scoped>
.partsrequest {
  color: #999999;

  .part {
    background: #efefef;
    border-radius: 10px;
    margin: 15px;
    padding: 5px;
    width: 400px;
    display: flex;
    justify-content: space-between;
  }
}

.container {
  display: flex;
  justify-content: center;
}

.add {
  height: 30px;
  justify-content: center;
}
</style>